import { render, staticRenderFns } from "./UpdatePersonal.vue?vue&type=template&id=3143fdc5"
import script from "./UpdatePersonal.vue?vue&type=script&lang=js"
export * from "./UpdatePersonal.vue?vue&type=script&lang=js"
import style0 from "./UpdatePersonal.vue?vue&type=style&index=0&id=3143fdc5&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports